export default {
  'ss.home': 'Home',
  'ss.specialServices': 'Special Services',
  'ss.planTitleA': 'Plan your',
  'ss.planTitleB': 'dream trip',
  'ss.planSubtitle': 'Tell us a little about your ideal journey and a local expert will get back to you within 24 hours with a tailored plan — no templates, no copy-paste.',
  'ss.replyTitle': 'Reply within 24 hours',
  'ss.replyDesc': 'A real expert reviews your request — not an automated response.',
  'ss.pricingTitle': 'Transparent pricing',
  'ss.pricingDesc': 'Every proposal comes with a clear breakdown — no hidden fees.',
  'ss.adjustTitle': 'Free to adjust',
  'ss.adjustDesc': 'We refine the plan until it is exactly what you imagined.',
  'ss.formTitle': 'Start planning',
  'ss.formSubtitle': "Fill in the form and we'll craft your itinerary.",
  'ss.fullName': 'Full name',
  'ss.email': 'Email',
  'ss.phone': 'Phone / WhatsApp',
  'ss.fullAddress': 'Full address',
  'ss.destination': 'Destination',
  'ss.travelDate': 'Travel date',
  'ss.groupSize': 'Group size',
  'ss.budget': 'Budget per person',
  'ss.travelIdeas': 'Your travel ideas',
  'ss.yourName': 'Your name',
  'ss.emailPlaceholder': 'you@example.com',
  'ss.phonePlaceholder': '+84 ...',
  'ss.addressPlaceholder': 'Street, city, country...',
  'ss.messagePlaceholder': "Tell us about your ideal trip — what you love, who's travelling, and anything special you'd like to include...",
  'ss.destNotSure': 'Not sure yet',
  'ss.destNorth': 'Northern Vietnam (Hanoi, Sapa, Ha Long)',
  'ss.destCentral': 'Central Vietnam (Hoi An, Hue, Da Nang)',
  'ss.destSouth': 'Southern Vietnam (HCMC, Mekong Delta)',
  'ss.destWhole': 'Whole Vietnam',
  'ss.groupSolo': '1 (solo)',
  'ss.groupCouple': '2 (couple)',
  'ss.group3to5': '3 - 5',
  'ss.group6to10': '6 - 10',
  'ss.group10plus': '10+',
  'ss.budgetUnder500': 'Under $500',
  'ss.budget500to1000': '$500 - $1,000',
  'ss.budget1000to2000': '$1,000 - $2,000',
  'ss.budget2000plus': '$2,000+',
  'ss.sending': 'Sending...',
  'ss.planMyTrip': 'Plan my trip',
  'ss.success': 'Thank you! A local expert will get back to you within 24 hours with your tailored plan.',
  'ss.sendFailed': 'Failed to send inquiry. Please try again.',
  'ss.networkError': 'A network error occurred. Please try again.',
  'ss.heroAlt': 'Vietnam Special Services',
  'ss.heroTitle': 'Vietnam Special Services Travel',
  'ss.ctaAlt': 'Vietnam Special Services CTA',
  'ss.ctaTitle': 'Vietnam Travel Special Services',
  'ss.visaAlt': 'Vietnam visa assistance',
  'ss.visaTitle': 'Vietnam Visa Assistance Service',
  'ss.captchaRequired': 'Please confirm you are not a robot.',
  'ss.captchaFailed': 'Security verification failed. Please try again.',
};